import React,  { useEffect, useState } from 'react';
import { Typography, Box, Button,FormControl,
  InputLabel,
  MenuItem,
  Select, TextField } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import Slide from '@mui/material/Slide';
import classes from "./controls.module.scss";
import { Icon } from '@genesis/ui-kit';
import axios from "axios";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { methods } from "underscore";
import { useNavigate } from "react-router-dom";
import { constants } from "../../Shared/Url/Constants";
import { CheckIsUserAdmin } from "../../Shared/Utill/Utills";
import SnackBar from "../../Shared/Snackbar/Snackbar";
import { toUpperCaseString } from '../../Shared/Utill/Utills';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const AddRecordDialog = (props) => {
  const [value, setValue] = useState("");
  const [divList, setDivList] = useState([]);
  const [divSelectedValue, setDivSelectedValue] = useState(props.divData);
  const [appList, setAppList] = useState([]);
  const [appSelectedValue, setAppSelectedValue] = useState(props.appData);
  const [activeValue, setActiveValue] = useState("");
  const personDetails = useSelector((state) => state.person.personData);
  const urlDetails = useSelector((state) => state.url.urlData);
  const token = Cookies.get('X_TKN');
  const history = useNavigate();
  const dialog = useToggle();
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};

     
  useEffect(() => {
    dialog.show();
  }, []);

  useEffect(() => {
    let divList = [];
      divList.push(props.divData);
      setDivList(divList);
    setDivSelectedValue(props.divData);
    let qppList = [];
    appList.push(props.appData);
    setAppList(appList);
    setAppSelectedValue(props.appData);
  },[props.divData, props.appData]);

  useEffect(() => {
    //call the API source for division list
    //getDivisionListSource();
   },[]); 

   useEffect(() => {
    //getApplicationDropdownByDivNbr(divSelectedValue);
   },[divSelectedValue]);

  const getDivisionListSource = () =>{
    // personDetails.mydiv; // my divNbr
    if(toUpperCaseString(personDetails.avail_admin) === "D"){
      getMyDivisionDetail();
    }
    else if(toUpperCaseString(personDetails.avail_admin) === "A"){
      getAllDivisionsList();
    }
    
  }
  
  //Network API request to get All divisions
  const getAllDivisionsList = () => {
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_ALL_DIVISIONS_URL}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      
      setDivList(res.data);
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_ALL_DIVISIONS_URL}...failed`})
        }
    });

  }

  //Network API request to get my Division detail
  const getMyDivisionDetail = () => {
    let myDivNbr =personDetails.mydiv;
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_DIV_DETAIL_BY_DIVNBR}/${myDivNbr}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      let divList = [];
      divList.push(res.data);
      setDivList(divList);
      setDivSelectedValue(res.data);
    }).catch((err) => {
      if(err.message === 'Network Error') {
        history("/somethingwentwrong", {state:`Please logout and try again `})
      }else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_DIV_DETAIL_BY_DIVNBR}...failed`})
        }
     
    });

  }

  const onDivDropDownSelect = (event) => {
    let selectedDivision = event.target.value;
    setDivSelectedValue(selectedDivision);
  }

  //Network API request to get application dropdown
  const getApplicationDropdownByDivNbr = (selectedDivision) => {
    if(selectedDivision === null){
      return;
    }
    let divNbr = selectedDivision.divNbr;
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_APP_BY_DIV_NBR}/${divNbr}`,
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
      },
    }).then((res) => {
      setAppList(res.data);
    }).catch((err) => {
    
    });

  }

  const onAppDropDownSelect = (event) => {
    let selectedApp = event.target.value;
    setAppSelectedValue(selectedApp);
  }

  const onActiveDropDownSelect = (event) => {
    let activeSts = event.target.value;
    setActiveValue(activeSts);
  }
    const dialogCLose = () => {
      dialog.hide();
      props.onCloseDialog();
    }
    const onSaveFailure = (errorMessage) => {
      //dialog.hide();
      //props.onCloseDialog();
      setAlertOpen({
        open: true,
        severity: "error",
        message : errorMessage,
      })
    }
    const onSaveSuccess = () => {
      dialog.hide();
      props.onSuccessDialog();
    }

    const onClickSaveButton = () => {
      addNewControlAPIcall();
    }

    const handleAlertNotifClose = () => {
      setAlertOpen({});
    };
    
  const addNewControlAPIcall = () => {
    if(appSelectedValue.appAbbr === "sea") {
      let requestPayload = {
        "divNbr": divSelectedValue.divNbr,
        "appAbbr": appSelectedValue.appAbbr,
        "locNbr": value !== "" ? value : null ,
        "pwhGrpNbr": 0,
        "ctlName": "Active",
        "ctlDesc": "Active",
        "value1": activeValue !== "" ? activeValue : null ,
        "value2": null,
        "lastUpdatedBy": personDetails.emplID
      }

      axios({
        url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_APP_CONTROL_ADD_BY_DIV_LOC_NBR_ABBR_CTLNAME}`,
        method: "POST",
        data: requestPayload,
        headers:{
          'Content-Type': 'application/json',
          'Authorization':'Bearer ' + token,
        },
      }).then((response) => {
          //console.log(response)
          if(response.status === 200){
            onSaveSuccess();
          }
          if(response.status === 400){
            onSaveFailure("Error 400");
          }
          if(response.status === 500){
            onSaveFailure("Error 500");
          }
        })
        .catch((error) => {
          console.log("ERROR Add NEW Control --> "+ JSON.stringify(error.response.data.message));
          onSaveFailure(JSON.stringify(error.response.data.message));
        })
      } else {

        let requestPayload = {
            action:"D",
            divNbr: divSelectedValue.divNbr,
            locNbr: value !== "" ? value : null,
            duplicateFromLocNbr: 0,
            active: activeValue !== "" ? activeValue : null,
            avlShiftSelectXminsApart: "",
            wksout:"",
            newHireActive:"n",
            newHireForXdays:"",
            workScheduleActive:"n",
            workScheduleUnlocked:"",
            lastUpdatedBy: personDetails.emplID
        }
       
        /*
        axios({
          url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_APP_CONTROL_ADD_EDIT_ADMIN_APP_LOCATION_CONTROLS}`,
          method: "POST",
          data: requestPayload,
          headers:{
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' + token,
          },
        }).then((response) => {
            //console.log(response)
            if(response.status === 200){
              onSaveSuccess();
            }
            if(response.status === 400){
              onSaveFailure("Error 400");
            }
            if(response.status === 500){
              onSaveFailure("Error 500");
            }
          })
          .catch((error) => {
            console.log("ERROR Add NEW Control --> "+ JSON.stringify(error.response.data.message));
            onSaveFailure(JSON.stringify(error.response.data.message));
          })
          */
      } // availability

    }

    return (
      <Box>
        <Dialog
          fullScreen
          open={dialog.open}
          title='Add Record'
          onClose={dialogCLose}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
                width: "35%",
                maxWidth: '35%',
                minHeight: "100%",
                display:"flex",
                left:'33%',     
            },
        }}
        >
      <FormControl  sx={{ minWidth: '100%', marginTop: 10  }}>
      <InputLabel id="demo-select-basic-label">Division</InputLabel>
      <Select
        labelId="demo-select-basic-label"
        id="demo-select-basic"
        label="Dropdown Label"
        disabled={true}
        onChange={e => onDivDropDownSelect(e)}
        value={divSelectedValue || ''}
      >
        {divList && divList.map((e) =>
          <MenuItem key={e.divNbr} value={e}>{e.divNbr + "-" + e.divName}</MenuItem>
        )}
      </Select>
    </FormControl>

    <FormControl  style={{ minWidth: '100%',  marginTop: 30   }}>
      <InputLabel id="demo-select-basic-label">Application</InputLabel>
      <Select
        labelId="demo-select-basic-label"
        id="demo-select-basic"
        label="Dropdown Label"
        disabled={true}
        onChange={e => onAppDropDownSelect(e)}
        value={appSelectedValue}>
         {appList && appList.map((e) =>
          <MenuItem key={e.appId} value={e}>{e.appName}</MenuItem>
        )}
      </Select>
    </FormControl>

    <FormControl style={{  minWidth: '100%', marginTop: 30 }}>
      <TextField 
      label="Location"
      onChange={(e) => setValue(e.target.value)}
      value={value}
      type="number"
      controls={false} 
       InputProps={{
         endAdornment: value && (
          <Icon 
          name='clear' 
           fontSize="30px"
           color="gray2"
           onClick={() => setValue("")}>
           </Icon>
         )
       }}
       />
    </FormControl>
    <FormControl style={{ minWidth: '100%', marginTop: 30  }}>
      <InputLabel id="demo-select-basic-label">Status</InputLabel>
      <Select
        labelId="demo-select-basic-label"
        id="demo-select-basic"
        label="Dropdown Label"
        onChange={e => onActiveDropDownSelect(e)}
        value={activeValue}>
          <MenuItem key={"1"} value={"y"}>{"On"}</MenuItem>
          <MenuItem key={"2"} value={"n"}>{"Off"}</MenuItem>
      </Select>
    </FormControl>
    <Button disabled={activeValue === "" || value === ""} style={{ minWidth: '100%', marginTop: 30, paddingTop: 15, paddingBottom: 15 }} onClick={onClickSaveButton}>Add</Button>
    <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
        </Dialog>
      </Box>
    );
  };
  
  export default AddRecordDialog;